import { ReactNode, Suspense } from "react";
import { Spinner } from "reactstrap";
import { AnimatePresence } from "motion/react";
import CategoryPreview from "../CategoryPreview";
import "./style.scss";
import classNames from "classnames";
import { Asset } from "../../types/Asset";
import { CollectionLink } from "../../types/CollectionLink";

export type CategoryGridItem = {
  value: {
    category: CollectionLink;
    description: string;
    image: Asset;
  };
  children?: ReactNode;
};

const CategoryGrid = ({
  items,
  isShop,
  className
}: {
  items: CategoryGridItem[];
  isShop?: boolean;
  className?: string;
}) => {
  //console.log(items)

  return (
    <div className={classNames("category-grid", className)} role="list">
      <AnimatePresence initial={false}>
        {items.map((item, idx) => (
          <CategoryPreview
            key={idx}
            categoryId={item.value.category._id}
            description={item.value.description}
            image={item.value.image}
            isShop={isShop}
          >
            {item.children}
          </CategoryPreview>
        ))}
      </AnimatePresence>
    </div>
  );
};

export const CockpitCategoryGrid = ({
  items
}: {
  items: CategoryGridItem[];
}) => {
  return (
    <Suspense fallback={<Spinner />}>
      <CategoryGrid items={items} />
    </Suspense>
  );
};

export default CategoryGrid;
